export interface Tenant {
  name: string;
  menu: string[];
  image?: string;
  location: string;
  year: number;
}

export const tenants: Tenant[] = [
  {
    location: "Lobby A",
    name: "Gwonppang x Sweetart",
    image: "/images/Gwonppang.jpg",
    menu: ["Gwon Ppang (kue koin)", "Snow Ice", "Bakso Goreng", "Popcorn"],
    year: 2024,
  },
  {
    location: "Lobby A",
    name: "STEAKEN CHICK",
    image: "/images/SteakenChick.jpg",
    menu: ["Steak Ayam", "Nasi Sapi Iris", "Hotdog"],
    year: 2024,
  },
  {
    location: "Lobby A",
    name: "Waroeng X52",
    image: "/images/WaroengX52.jpg",
    menu: [
      "Siomay",
      "Batagor",
      "Telur Gulung",
      "Sosis Bakar",
      "Sosis Gulung Telur",
      "Cilok Kukus",
      "Cilok Goreng",
      "Nasi Ayam Geprek",
      "Rujak Buah",
      "Gado-Gado",
      "Ketoprak",
    ],
    year: 2024,
  },
  {
    location: "Lobby A",
    name: "Pempek Pindang Acu",
    image: "/images/PempekPindangAcu.jpg",
    menu: ["Pempek", "Tekwan", "Mie Celor"],
    year: 2024,
  },
  {
    location: "Lobby A",
    name: "Milfood",
    image: "/images/MilFood.jpg",
    menu: [
      "Nugget",
      "Otak-Otak",
      "Pancake Durian Mini",
      "Pancake Durian Medan",
      "Minuman",
    ],
    year: 2024,
  },
  {
    location: "Lobby A",
    name: "3S",
    image: "/images/3S.jpeg",
    menu: [
      "Ropang",
      "Sosis Goreng",
      "Keripik Pisang",
      "Paket Nasi Ayam Crispy",
      "Pisang Bakar",
      "Stik Pisang Goreng",
      "Pakte Nasi Bogem",
    ],
    year: 2024,
  },
  {
    location: "Lobby A",
    name: "Kedai Jajan Snacksa",
    image: "/images/KedaiJajanSnacksa.jpg",
    menu: ["Crepes", "Bakso Malang", "Mochi", "Jasuke"],
    year: 2024,
  },
  {
    location: "Lobby A",
    name: "N'D LIO",
    image: "/images/NDLio.jpg",
    menu: [
      "Rice Bowl Ayam Bawang",
      "Rice Bowl Nasi Pedas Ayam Bakar",
      "Ketumbar",
      "Risol Sayur Ayam",
      "Risol Beef Mayo",
    ],
    year: 2024,
  },
  {
    location: "Junction Room",
    name: "Jelly Koe",
    image: "/images/JellyKoe.jpg",
    menu: ["Ice Jelly", "Silky Drink", "Jelly Cups", "Jelly Sedot"],
    year: 2024,
  },
  {
    location: "Lobby A",
    name: "Snack Ida",
    image: "/images/SnackIda.jpg",
    menu: [
      "Oyen Jumbo",
      "Chicongfafan",
      "Pastel",
      "Kue Basah",
      "Arem-Arem",
      "Lumpia",
      "Bakwan Goreng",
      "Ubi Goreng",
      "Wonton Chili Oil",
      "Pangsit Nampol",
      "Chili Oil",
      "Bakpau",
      "Roti Goreng",
    ],
    year: 2024,
  },
];
